module.exports = __webpack_public_path__ + "img/candy.dedb0572.jpg";